import { render, staticRenderFns } from "./LotterySvg.vue?vue&type=template&id=1db5c189&scoped=true"
import script from "./LotterySvg.vue?vue&type=script&lang=js"
export * from "./LotterySvg.vue?vue&type=script&lang=js"
import style0 from "./LotterySvg.vue?vue&type=style&index=0&id=1db5c189&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db5c189",
  null
  
)

export default component.exports